import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

import { colors } from '../mock-data/floor-mat-sheepskin-colors';

const TABS = [
  {
    name: 'Product Information',
    value: 'INFO',
    html: window?.conspire_product?.description
  },
  {
    name: 'Warranty',
    value: 'WARRANTY',
    html: window?.conspire_product_warranty
  },
  {
    name: 'FAQ',
    value: 'FAQ',
    html: window?.conspire_product_faq
  }
];

let selectedCar = {
  year: "",
  make: "",
  model: "",
  submodel: "",
  option: {}
};

try {
  selectedCar = {
    year: localStorage.getItem('fm-car-year') || "",
    make: JSON.parse(localStorage.getItem('fm-car-make')) || "",
    model: JSON.parse(localStorage.getItem('fm-car-model')) || "",
    submodel: localStorage.getItem('fm-car-submodel') || "",
    option: {}
  }
} catch (e) {
  console.log('error parsing selectedCar e', e);
}

const productOptions = [];

for (const variant of window.conspire_product.variants) {
  const option = variant.option1;

  if (!productOptions.includes(option)) {
    productOptions.push(option);
  }
}

const INITIAL_STATE = {
  tabs: TABS,
  colors,
  selectedColor: colors[0],
  selectedCar,
  quantity: 1,
  productOptions,
  selectedProductOption: productOptions?.[0],
  productVariant: {}
};

export const useSheepskinFloormatStore = create(
  immer((set) => ({
    ...INITIAL_STATE,
    setSelectedColor: (color) =>
      set((state) => {
        state.selectedColor = color;
      }),
    setSelectedCar: (car) =>
      set((state) => {
        state.selectedCar = car;
      }),
    setQuantity: (quantity) =>
      set((state) => {
        state.quantity = quantity;
      }),
    setProductVariant: (variant) =>
      set((state) => {
        state.productVariant = variant;
      }),
    setSelectedProductOption: (option) =>
      set((state) => {
        state.selectedProductOption = option;
      }),
  }))
);
